"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _bignumber = require("bignumber.js");
var _APButton = _interopRequireDefault(require("../common/APButton"));
var _APReactSelect = _interopRequireWildcard(require("../common/APReactSelect/APReactSelect"));
var _formValidations = require("../../helpers/formValidations");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _numberFormatter = require("../../helpers/numberFormatter");
var _FormItem = require("../form/FormItem/FormItem");
var _NumberInput = require("../form/NumberInput");
require("./MarginTransferAssetsModalComponent.css");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _Option = _APReactSelect.components.Option,
  _SingleValue = _APReactSelect.components.SingleValue;
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('margin-transfer-assets');
var MarginTransferAssetsFormComponent = /*#__PURE__*/function (_React$Component) {
  function MarginTransferAssetsFormComponent() {
    var _this;
    _classCallCheck(this, MarginTransferAssetsFormComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MarginTransferAssetsFormComponent, [].concat(args));
    _defineProperty(_this, "isEnough", function (value) {
      var _this$props = _this.props,
        t = _this$props.t,
        maxAmount = _this$props.maxAmount;
      var valueNumber = new _bignumber.BigNumber(value);
      var maxAmountNumber = new _bignumber.BigNumber(maxAmount);
      if (valueNumber.gt(maxAmountNumber)) {
        return t('Not enough funds');
      }
      return undefined;
    });
    _defineProperty(_this, "checkAccounts", function () {
      var _formObj$values$Sende2, _formObj$values$Recei;
      var t = _this.props.t;
      var _this$props2 = _this.props,
        formObj = _this$props2.formObj,
        accounts = _this$props2.accounts;
      var accountFrom = accounts.find(function (account) {
        var _formObj$values$Sende;
        return account.AccountId === Number((_formObj$values$Sende = formObj.values.SenderAccount) === null || _formObj$values$Sende === void 0 ? void 0 : _formObj$values$Sende.value);
      });
      if (((_formObj$values$Sende2 = formObj.values.SenderAccount) === null || _formObj$values$Sende2 === void 0 ? void 0 : _formObj$values$Sende2.value) === ((_formObj$values$Recei = formObj.values.ReceiverAccount) === null || _formObj$values$Recei === void 0 ? void 0 : _formObj$values$Recei.value)) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('error-message')
        }, t('Please select different To and From Accounts'));
      }
      if (_this.props.assetsWithBalances.length === 0) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('error-message')
        }, t('Assets cannot be transferred out of this account because the transferrable balance is zero'));
      }
      if ((accountFrom === null || accountFrom === void 0 ? void 0 : accountFrom.AccountType) === 'Margin' && _this.props.assetsWithBalances.length !== 0 && _this.props.UsableMarginNotional === 0) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('error-message')
        }, t('Assets cannot be transferred out of this account because Usable Margin is zero'));
      }
      return null;
    });
    _defineProperty(_this, "renderOptionItem", function (props, t) {
      var _this$props3 = _this.props,
        isMarginReceiver = _this$props3.isMarginReceiver,
        isFuturesReceiver = _this$props3.isFuturesReceiver;
      var productEnabled = props.data.isEnabled;
      var label = props.data.simpleLabel || props.data.label;
      if (!productEnabled) {
        if (isMarginReceiver) {
          label = t('{{Asset}} (Not enabled for margin)', {
            Asset: label
          });
        } else if (isFuturesReceiver) {
          label = t('{{Asset}} (Not enabled for futures)', {
            Asset: label
          });
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('option-row')
      }, /*#__PURE__*/_react["default"].createElement("span", null, label), /*#__PURE__*/_react["default"].createElement("small", null, (0, _numberFormatter.formatNumberToLocale)(props.data.amount, props.data.ProductSymbol)));
    });
    _defineProperty(_this, "formatOptionLabel", function (option) {
      var _this$props4 = _this.props,
        isMarginReceiver = _this$props4.isMarginReceiver,
        isFuturesReceiver = _this$props4.isFuturesReceiver,
        t = _this$props4.t;
      var productEnabled = option.isEnabled;
      if (!productEnabled) {
        if (isMarginReceiver) {
          return "".concat(option.label, " (").concat(t('Not enabled for margin'), ")");
        } else if (isFuturesReceiver) {
          return "".concat(option.label, " (").concat(t('Not enabled for futures'), ")");
        }
      }
      return option.label;
    });
    return _this;
  }
  _inherits(MarginTransferAssetsFormComponent, _React$Component);
  return _createClass(MarginTransferAssetsFormComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$formObj$v;
      if (this.props.isMarginSender && this.props.maxAmount === null && (_this$props$formObj$v = this.props.formObj.values.Product) !== null && _this$props$formObj$v !== void 0 && _this$props$formObj$v.value) {
        this.props.getMaxTransferAmount(this.props.formObj.values.Product.value);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _prevProps$formObj$va, _this$props$formObj$v2, _prevProps$formObj$va2, _this$props$formObj$v4, _this$props$formObj$v5, _this$props$formObj$v6, _this$props$formObj$v7, _this$props$formObj$v8, _prevProps$formObj$va3, _this$props$formObj$v9;
      if (prevProps.formObj.initial && ((_prevProps$formObj$va = prevProps.formObj.values.SenderAccount) === null || _prevProps$formObj$va === void 0 ? void 0 : _prevProps$formObj$va.value) !== ((_this$props$formObj$v2 = this.props.formObj.values.SenderAccount) === null || _this$props$formObj$v2 === void 0 ? void 0 : _this$props$formObj$v2.value)) {
        var _this$props$formObj$v3, _this$props$assetsWit;
        var currentProductId = (_this$props$formObj$v3 = this.props.formObj.values.Product) === null || _this$props$formObj$v3 === void 0 ? void 0 : _this$props$formObj$v3.ProductId;
        var currentProduct = (_this$props$assetsWit = this.props.assetsWithBalances) === null || _this$props$assetsWit === void 0 ? void 0 : _this$props$assetsWit.find(function (asset) {
          return asset.ProductId === currentProductId;
        });
        this.props.change('Product', currentProduct !== null && currentProduct !== void 0 ? currentProduct : null);
      }
      // Fetch margin max transfer amount if product changes and sender account is margin
      if (((_prevProps$formObj$va2 = prevProps.formObj.values.Product) === null || _prevProps$formObj$va2 === void 0 ? void 0 : _prevProps$formObj$va2.value) !== ((_this$props$formObj$v4 = this.props.formObj.values.Product) === null || _this$props$formObj$v4 === void 0 ? void 0 : _this$props$formObj$v4.value) && (_this$props$formObj$v5 = this.props.formObj.values.Product) !== null && _this$props$formObj$v5 !== void 0 && _this$props$formObj$v5.value && this.props.isMarginSender && this.props.maxAmount === null) {
        this.props.getMaxTransferAmount(this.props.formObj.values.Product.value);
      }
      // Fetch margin max transfer amount if sender account changes to margin. For scenarios where user switches accounts but not products
      if (!prevProps.isMarginSender && this.props.isMarginSender && (_this$props$formObj$v6 = this.props.formObj.values.Product) !== null && _this$props$formObj$v6 !== void 0 && _this$props$formObj$v6.value && this.props.maxAmount === null) {
        this.props.getMaxTransferAmount(this.props.formObj.values.Product.value);
      }
      // If To Account is switched to margin and collateral not enabled for given asset, then reset product
      if (prevProps.isMarginReceiver !== this.props.isMarginReceiver) {
        var _this$props$assetsWit2;
        var Product = this.props.formObj.values.Product;
        var productIsEnabled = (_this$props$assetsWit2 = this.props.assetsWithBalances.find(function (asset) {
          return asset.ProductId === (Product === null || Product === void 0 ? void 0 : Product.ProductId);
        })) === null || _this$props$assetsWit2 === void 0 ? void 0 : _this$props$assetsWit2.isEnabled;
        if (!productIsEnabled) {
          this.props.change('Product', '');
        }
      }
      // If product with 0 balance is selected, then reset product
      var productBalance = (_this$props$formObj$v7 = this.props.formObj.values.Product) === null || _this$props$formObj$v7 === void 0 ? void 0 : _this$props$formObj$v7.amount;
      var decimalPlaces = (_this$props$formObj$v8 = this.props.formObj.values.Product) === null || _this$props$formObj$v8 === void 0 ? void 0 : _this$props$formObj$v8.DecimalPlaces;
      if (((_prevProps$formObj$va3 = prevProps.formObj.values.Product) === null || _prevProps$formObj$va3 === void 0 ? void 0 : _prevProps$formObj$va3.value) !== ((_this$props$formObj$v9 = this.props.formObj.values.Product) === null || _this$props$formObj$v9 === void 0 ? void 0 : _this$props$formObj$v9.value) && Math.abs(productBalance) < Math.pow(10, -decimalPlaces) // Some products can have very small balances. So we check based on decimal places for that product
      // For example, if product is USD (2 decimal places), then we check if balance less to 0.01
      ) {
        this.props.change('Product', '');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _formObj$values$Sende4,
        _formObj$values$Recei3;
      var _this$props5 = this.props,
        t = _this$props5.t,
        accounts = _this$props5.accounts,
        formObj = _this$props5.formObj,
        handleSubmit = _this$props5.handleSubmit,
        pristine = _this$props5.pristine,
        invalid = _this$props5.invalid,
        loading = _this$props5.loading,
        change = _this$props5.change,
        untouch = _this$props5.untouch,
        maxAmount = _this$props5.maxAmount,
        DecimalPlaces = _this$props5.DecimalPlaces,
        assetsWithBalances = _this$props5.assetsWithBalances;
      var arrow = /*#__PURE__*/_react["default"].createElement("p", {
        className: bemClasses('arrow'),
        onClick: function onClick() {
          var _formObj$values$Sende3, _formObj$values$Recei2;
          if ((_formObj$values$Sende3 = formObj.values.SenderAccount) !== null && _formObj$values$Sende3 !== void 0 && _formObj$values$Sende3.value && (_formObj$values$Recei2 = formObj.values.ReceiverAccount) !== null && _formObj$values$Recei2 !== void 0 && _formObj$values$Recei2.value) {
            change('SenderAccount', formObj.values.ReceiverAccount);
            change('ReceiverAccount', formObj.values.SenderAccount);
            // setTimeout below ensures both change actions dispatch. Without setTimeout, only change('Product') dispatches properly
            setTimeout(function () {
              return change('Amount', 0);
            });
            untouch('Amount');
            change('Product', '');
            untouch('Product');
          }
        }
      }, '←→');
      var selectAccountOptions = accounts.map(function (account) {
        return {
          value: account.AccountId,
          label: account.AccountName,
          accountType: account.AccountType
        };
      });
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit,
        className: bemClasses('form')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('description')
      }, t('Here you can transfer assets between accounts')), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('inline-container')
      }, /*#__PURE__*/_react["default"].createElement(_APReactSelect["default"], {
        name: "SenderAccount",
        label: "".concat(t('From Account')),
        customClass: bemClasses(),
        options: selectAccountOptions
      }), arrow, /*#__PURE__*/_react["default"].createElement(_APReactSelect["default"], {
        name: "ReceiverAccount",
        label: "".concat(t('To Account')),
        customClass: bemClasses(),
        options: selectAccountOptions
      }), this.checkAccounts()), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('asset-fields-container')
      }, /*#__PURE__*/_react["default"].createElement(_APReactSelect["default"], {
        name: "Product",
        label: "".concat(t('Asset')),
        placeholder: t('Select...', {
          ns: 'core'
        }),
        customClass: bemClasses(),
        options: assetsWithBalances,
        isSearchable: false,
        onSelect: function onSelect() {
          change('Amount', 0);
          untouch('Amount');
        },
        isOptionDisabled: function isOptionDisabled(option) {
          return option.isEnabled === false;
        },
        formatOptionLabel: this.formatOptionLabel,
        components: {
          Option: function Option(props) {
            return /*#__PURE__*/_react["default"].createElement(_Option, props, _this2.renderOptionItem(props, t));
          },
          SingleValue: function SingleValue(props) {
            return /*#__PURE__*/_react["default"].createElement(_SingleValue, props, _this2.renderOptionItem(props, t));
          }
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "margin-transfer-assets_amt-container"
      }, /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
        component: _NumberInput.MaxAmountInput,
        name: "Amount",
        size: "small",
        validate: [_formValidations.required, this.isEnough],
        className: 'margin-transfer-assets_amt-field',
        label: t('Amount'),
        maxValue: maxAmount || 0,
        maxButtonSize: "xs",
        decimalPlaces: DecimalPlaces,
        valueAs: "string"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('btn-container')
      }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        type: "submit",
        customClass: bemClasses(),
        disabled: Number(formObj.values.Amount) === 0 || !formObj.values.Product || ((_formObj$values$Sende4 = formObj.values.SenderAccount) === null || _formObj$values$Sende4 === void 0 ? void 0 : _formObj$values$Sende4.value) === ((_formObj$values$Recei3 = formObj.values.ReceiverAccount) === null || _formObj$values$Recei3 === void 0 ? void 0 : _formObj$values$Recei3.value) || invalid || pristine || loading || !!this.checkAccounts()
      }, loading ? t('Loading') : t('Confirm'))));
    }
  }]);
}(_react["default"].Component);
MarginTransferAssetsFormComponent.propTypes = {
  formObj: _propTypes["default"].object.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  invalid: _propTypes["default"].bool.isRequired,
  pristine: _propTypes["default"].bool.isRequired,
  maxAmount: _propTypes["default"].number,
  assets: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].number.isRequired,
    label: _propTypes["default"].string.isRequired,
    amount: _propTypes["default"].number,
    ProductSymbol: _propTypes["default"].string,
    ProductId: _propTypes["default"].number
  })).isRequired,
  accounts: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].number.isRequired,
    label: _propTypes["default"].string.isRequired
  })).isRequired,
  assetsWithBalances: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].number.isRequired,
    label: _propTypes["default"].string.isRequired,
    amount: _propTypes["default"].number.isRequired,
    ProductSymbol: _propTypes["default"].string.isRequired,
    ProductId: _propTypes["default"].number.isRequired
  })),
  isMarginReceiver: _propTypes["default"].bool,
  isFuturesReceiver: _propTypes["default"].bool
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('margin')(MarginTransferAssetsFormComponent);